import { hexToUnitRgba, unitColorChannelToByte, unitRgbToHex } from "../../utils/colorUtils";

export const TENDON_COEFFICIENT_INFO =
  "Coefficient scales each joint's contribution to tendon length.\n" +
  "Positive values move in the same direction; negative values invert.\n" +
  "Larger magnitude means that joint contributes more strongly.";

export const SPATIAL_ROUTE_INFO =
  "Spatial tendons follow a route through sites and optional wrap geoms.\n" +
  "Geom Wrap selects a sphere or cylinder that the tendon bends around.\n" +
  "The second field is the optional sidesite, which tells MuJoCo which side of the wrap geom the tendon should pass.";

export const isScalarJoint = (joint) => joint?.kind === "hinge" || joint?.kind === "slide";
export const isSpatialTendon = (tendon) => tendon?.kind === "spatial";
export const DEFAULT_WRAP_COLOR = [0.1, 0.9, 0.3, 0.4];

export const materialSwatchStyle = (material) => {
  const color = Array.isArray(material?.color) ? material.color : null;
  if (!color || color.length < 3) return { backgroundColor: "#6b7280" };
  const [r, g, b, a = 1] = color;
  return {
    backgroundColor: `rgba(${unitColorChannelToByte(r)}, ${unitColorChannelToByte(g)}, ${unitColorChannelToByte(b)}, ${Math.max(0, Math.min(1, Number(a) || 0))})`,
  };
};

export const colorToHex = (color) => unitRgbToHex(color, DEFAULT_WRAP_COLOR);

export const hexToColor = (hex, alpha = DEFAULT_WRAP_COLOR[3]) => {
  return hexToUnitRgba(hex, alpha, DEFAULT_WRAP_COLOR);
};

export const TENDON_TYPE_OPTIONS = [
  { value: "fixed", label: "Fixed" },
  { value: "spatial", label: "Spatial" },
];

export const SPATIAL_ROUTE_TYPE_OPTIONS = [
  { value: "site", label: "Site" },
  { value: "geom", label: "Geom Wrap" },
  { value: "pulley", label: "Pulley" },
];

export const INLINE_SPATIAL_ROUTE_EDITOR_LIMIT = 12;
export const SPATIAL_ROUTE_PREVIEW_LIMIT = 8;
